import React, { useState, useEffect, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { HeaderTrans, ProfileTrans } from '../utils/translations';
import { useAppContext } from '../context/AppContext';
import { useLocation, useNavigate } from "react-router-dom";
import profilePlaceholder from "../assets/profile.png";

const LoginButton = () => {
  const location = useLocation();
  const { language, user } = useAppContext();
  const { loginWithRedirect, logout } = useAuth0();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef(null);

  const logIn = () => {
    window.localStorage.setItem("redirectTo", location.pathname !== "/landing" || "/onlineClub" ? location.pathname : "/library");
    loginWithRedirect({ui_locales: navigator.language || "ru"});
  };

  const logOut = () => {
    logout({ returnTo: window.location.origin + "/landing" });
    setShowUserMenu(false);
  };

  const goToProfile = () => {
    navigate("/profile");
    setShowUserMenu(false);
  };

  // Close the menu if clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowUserMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return !user ? (
    <button className="hover:text-pink" onClick={logIn}>
      {HeaderTrans[language].login}
    </button>
  ) : (
    <div className="relative" ref={menuRef}>
      <img
        src={user?.picture || profilePlaceholder}
        alt="User profile"
        className="w-7 h-7 rounded-full cursor-pointer"
        onClick={() => setShowUserMenu(!showUserMenu)}
        onError={(e) => { e.currentTarget.src = profilePlaceholder }}
      />
      {showUserMenu && (
        <ul className="absolute -right-2 md:-right-8 mt-1 bg-white border rounded-lg shadow-lg w-fit z-20 cursor-pointer">
            <li>
              <button
                onClick={goToProfile}
                className="block w-full text-left px-4 py-2 rounded hover:bg-beige hover:text-white"
              >
                {ProfileTrans[language].profile}
              </button>
            </li>
            <li>
              <button
                onClick={logOut}
                className="block w-full text-left px-4 py-2 rounded hover:bg-beige hover:text-white"
              >
                {ProfileTrans[language].logout}
              </button>
            </li>
        </ul>
      )}
    </div>
  );
};

export default LoginButton;
